const actionPopups = document.querySelectorAll('[data-popup]');

const initialisePopup = dataset => {
  let data;
  try {
    data = JSON.parse(dataset.popup || '{}');
  } catch (e) {
    console.warn('Bad JSON in data-popup', e);
    return;
  }
  if (!data.content) return;

  const mediaMarkup = (data.media || '').replace(/team__/g, 'popup__');

  const dialog = document.createElement('dialog');
  dialog.className = 'popup';
  dialog.innerHTML = `
    <div class="popup__wrapper" data-width="${data.width || 'wide'}">
      <div class="popup__container">
        ${mediaMarkup || ''}
        <div class="popup__content">${data.content}</div>
      </div>
    </div>
     <button class="popup__close" aria-label="Close">
        <i class="icon icon--close"></i>
      </button>
  `;

  const close = () => {
    // Start fade-out
    dialog.classList.remove('is-visible');

    // Wait for transition **or** animation to finish
    const finish = () => {
      dialog.removeEventListener('animationend', finish);
      dialog.removeEventListener('transitionend', finish);
      dialog.close();   // removes [open] and backdrop
      dialog.remove();  // remove from the DOM
    };

    dialog.addEventListener('animationend', finish,   { once: true });
    dialog.addEventListener('transitionend', finish, { once: true });
  };

  dialog.addEventListener('click', e => {
    if (e.target.closest('.popup__close') || e.target === dialog) close();
  });

  dialog.addEventListener('cancel', e => {
    e.preventDefault(); // prevent instant close
    close();
  });

  document.body.appendChild(dialog);
  dialog.showModal();
  requestAnimationFrame(() => {   // next frame → add class
    dialog.classList.add('is-visible');
  });
};

actionPopups.forEach(el => {
  el.addEventListener('click', e => {
    e.preventDefault();          // cancel any nested <a> default
    initialisePopup(el.dataset); // the whole card is the trigger
  });
});